import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import Config from 'config';
import { isEmpty } from 'lodash';
import KEY_ACTIVE_STUDENTS_REPORT_ASYNC_QUERY from 'graph/reports/key-active-students-report-async-query';
import RadialChartCard, { ChartData } from '../../../../charts/RadialChartCard';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import { ChartCardType } from '../../../../types';
import { getQueryVariables } from '../../../../utils/report-param-utils';

const ActiveStudentsChart: React.FC = () => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);
  const [{ entityId, entityType, dateRange }] = useReportQueryParams();
  const [fetchReport, { data, error, stopPolling }] = useLazyQuery(
    KEY_ACTIVE_STUDENTS_REPORT_ASYNC_QUERY,
    {
      pollInterval: Config.reporting.asyncPollIntervalMs
    }
  );

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType, dateRange }) as any });
  }, [fetchReport, entityId, entityType, dateRange]);

  const chartData: ChartData = {};

  if (error) {
    stopPolling?.();
  } else if (data?.keyActiveStudentsReportAsync?.result) {
    stopPolling?.();

    const { activeStudentCount, totalStudentCount } = data.keyActiveStudentsReportAsync.result;
    chartData.progress = activeStudentCount;
    chartData.total = totalStudentCount;
  }

  return (
    <RadialChartCard
      type={ChartCardType.COUNT}
      title={t('Active Students')}
      helpText={t('totalAndActiveStudents', { ns: 'ReportsHelpCharts' })}
      color="#006db8"
      loading={isEmpty(chartData)}
      {...chartData}
    />
  );
};

export default React.memo(ActiveStudentsChart);
